import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "position"]

  up() {
    if (!this.previousSibling) return
    this.positionTarget.value--
    this.previousSibling.querySelector('input').value++
    this.previousSibling.before(this.element)
  }

  down() {
    if (!this.nextSibling) return
    this.positionTarget.value++
    this.nextSibling.querySelector('input').value--
    this.nextSibling.after(this.element)
  }
  
  get previousSibling() {
    return this.element.previousElementSibling
  }

  get nextSibling() {
    return this.element.nextElementSibling
  }
}
